export const HIDE_COMMUNITY = true;
export const ENABLE_NEXT_YEAR_CROPS = true;
